// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__3_P6c","errorLogs":"styles_errorLogs__2xKPO"};